import { Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
import BigNumber from 'bignumber.js'
import Web3 from 'web3'

import pangolinABI from '../abi/pangolin.json'
import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { findToken, makeBatchRequest } from '../utils'

export const getPangolinFarm = async (
  walletAddress: string,
  contract: Contract,
  tokens: Token[],
  priceList: PriceList,
  web3Prop: Web3
): Promise<Stake[]> => {
  try {
    const { contractAddress, routerAddress, rewardAddress } = contract
    const web3 = web3Prop || new Web3(getNodeUrl(43114))
    const ct = new web3.eth.Contract(pangolinABI as any, contractAddress)

    const [balance, pendingReward, lpAddress] = await makeBatchRequest(web3, [
      ct.methods.balanceOf(walletAddress).call,
      ct.methods.earned(walletAddress).call,
      ct.methods.stakingToken().call
    ])
    const reward = new BigNumber(pendingReward as string).dividedBy(`1e18`).toNumber()
    const stakeAmount = balance
    const rewardUSD = reward * priceList[rewardAddress]?.usd || 0
    const rewardSymbol = findToken(tokens, rewardAddress)?.symbol ?? '???'

    const balanceInfo = await calculate(
      web3,
      {
        lpAddress: lpAddress,
        pool: 0,
        availableBalanceOf: '0',
        balance: stakeAmount
      },
      routerAddress,
      tokens,
      priceList
    )
    const result: Stake = {
      ...contract,
      ...balanceInfo,
      reward: +reward,
      rewardSymbol,
      rewardUSD
    }

    return [result]
  } catch (e) {
    console.log('bug pangolin farm', e)
    return []
  }
}
